import { AutomaticConfiguration, RandomConfiguration } from "./algorithm-configurations.js";
import { ElkForceConfiguration, ElkLayeredConfiguration, ElkRadialConfiguration, ElkSporeOverlapConfiguration, ElkStressAdvancedUsingClustersConfiguration, ElkStressConfiguration, ElkStressProfileLayoutConfiguration } from "./elk/elk-configurations.js";
export function isUserGivenAlgorithmConfigurationInterface(what) {
    if (what === undefined || what === null || what?.layout_alg === undefined) {
        return false;
    }
    switch (what.layout_alg) {
        case "elk_layered":
        case "elk_stress":
        case "elk_stress_profile":
        case "elk_stress_advanced_using_clusters":
        case "automatic":
        case "elk_radial":
        case "elk_overlapRemoval":
        case "none":
        case "elk_force":
        case "random":
            return true;
        default:
            throw new Error(`Unknown layout_alg: ${what.layout_alg}`);
    }
}
export function isUserGivenAlgorithmConfigurationLayered(what) {
    return what?.layout_alg === "elk_layered";
}
export function isUserGivenAlgorithmConfigurationStress(what) {
    return what?.layout_alg === "elk_stress";
}
export function isUserGivenAlgorithmConfigurationStressProfile(what) {
    return what?.layout_alg === "elk_stress_profile";
}
export function isUserGivenAlgorithmConfigurationStressWithClusters(what) {
    return what.layout_alg === "elk_stress_advanced_using_clusters";
}
export function isUserGivenAlgorithmConfigurationAutomatic(what) {
    return what?.layout_alg === "automatic";
}
export function isUserGivenAlgorithmConfigurationRadial(what) {
    return what?.layout_alg === "elk_radial";
}
export function isUserGivenAlgorithmConfigurationOverlapRemoval(what) {
    return what?.layout_alg === "elk_overlapRemoval";
}
export function isUserGivenAlgorithmConfigurationNone(what) {
    return what?.layout_alg === "none";
}
export function isUserGivenAlgorithmConfigurationElkForce(what) {
    return what?.layout_alg === "elk_force";
}
export function isUserGivenAlgorithmConfigurationRandom(what) {
    return what?.layout_alg === "random";
}
//
/**
 *
 * @returns Returns the configurations of the full thing, that is not only the algorithm configurations, but also the chosen algorithm.
 */
export function getDefaultUserGivenAlgorithmConfigurationsFull() {
    return {
        main: getDefaultUserGivenAlgorithmConfigurationsMap(),
        general: getDefaultUserGivenAlgorithmConfigurationsMap(),
        chosenMainAlgorithm: "elk_layered",
        chosenGeneralAlgorithm: "none",
        additionalSteps: {}
    };
}
/**
*
* @returns Returns the configurations of the algorithms - and only algorithms
*/
function getDefaultUserGivenAlgorithmConfigurationsMap() {
    return {
        none: {
            layout_alg: "none",
            advanced_settings: undefined,
            run_layered_after: false,
            run_node_overlap_removal_after: false,
            interactive: false
        },
        elk_stress: ElkStressConfiguration.getDefaultUserConfiguration(),
        elk_layered: ElkLayeredConfiguration.getDefaultUserConfiguration(),
        elk_force: ElkForceConfiguration.getDefaultUserConfiguration(),
        random: RandomConfiguration.getDefaultUserConfiguration(),
        elk_radial: ElkRadialConfiguration.getDefaultUserConfiguration(),
        elk_overlapRemoval: ElkSporeOverlapConfiguration.getDefaultUserConfiguration(),
        elk_stress_advanced_using_clusters: ElkStressAdvancedUsingClustersConfiguration.getDefaultUserConfiguration(),
        elk_stress_profile: ElkStressProfileLayoutConfiguration.getDefaultUserConfiguration(),
        automatic: AutomaticConfiguration.getDefaultUserConfiguration()
    };
}
;
//# sourceMappingURL=user-algorithm-configurations.js.map